//On DOM Load
jQuery(document).ready(function($) {

    var $body = $( 'body' );

    $('#main-nav .menu').slicknav({
        label: '',
        allowParentLinks: true,
        init: function(){
            $('.slicknav_nav').width($(window).width());
            $('.slicknav_nav').height($(window).height());
        }
    });

    $('#caseStudies .customLoop').slick({
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        fade: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        prevArrow: '<i class="fas fa-angle-left"></i>',
        nextArrow: '<i class="fas fa-angle-right"></i>',
        // responsive: [
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             arrows: false,
        //             centerMode: true,
        //             centerPadding: '40px',
        //             slidesToShow: 1
        //             }
        //         },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //         arrows: false,
        //             centerMode: true,
        //             centerPadding: '40px',
        //             slidesToShow: 1
        //         }
        //     }
        // ]
    })

    $('#testimonialSection .customLoop').slick({
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        prevArrow: '<i class="fas fa-angle-left"></i>',
        nextArrow: '<i class="fas fa-angle-right"></i>',
    })

    $('#newsSlider .customLoop').slick({
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        appendArrows: '.arrowBox',
        prevArrow: '<i class="fas fa-angle-left"></i>',
        nextArrow: '<i class="fas fa-angle-right"></i>',
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                appendArrows: '.secondaryTitle',
                }
            },
        ]
    })

    $( "#serviceTabs" ).tabs();
    $( "#subServiceTabs" ).tabs();

    if( is_case_study_archive() ) {

        var $archiveWrap = $( '#stellarCaseStudyArchiveWrap .archiveWrap' );
        var $preloader = $( '#stellarCaseStudyArchiveWrap .preloader' );
        var $industryFilter = $( '#industryFilter' );

        load_case_studies();

        $industryFilter.on( 'change', function() {

            var term_id = $( this ).val();

            $archiveWrap.data( 'term-id', term_id );
            $archiveWrap.data( 'page', 1 ); // reset page when changing terms
            load_case_studies();

        });

        $( document ).on( 'click', '#stellarCaseStudyArchiveWrap a.page, #stellarCaseStudyArchiveWrap a.prev, #stellarCaseStudyArchiveWrap a.next', function( e ) {

            e.preventDefault();

            var href = $( this ).attr( 'href' );
            var pos = href.indexOf( '?' );
            var query = pos >= 0 ? href.substring( pos ) : '';

            // should never happen, but who knows
            if( query == '' ) {
                $archiveWrap.data( 'page', 1 );
                load_case_studies();
                return;
            }

            var params = parseQuery( query );
            var page = params.paged;

            $archiveWrap.data( 'page', page );
            $( 'html, body' ).scrollTop( $industryFilter.offset().top );
            load_case_studies();

        } );

        function load_case_studies() {

            var _nonce = $( '#stellar_case_study_archive_nonce' ).val();
            var paged = $archiveWrap.data( 'page' );
            var term_id = $archiveWrap.data( 'term-id' );
    
            var case_study_archive_data = {
                action: 'stellar_theme_load_case_studies',
                _nonce,
                paged,
                term_id,
            };
    
            $preloader.show();
            $archiveWrap.html( '' );
    
            $.post(
                stellar_ajax_opts.ajax_url,
                case_study_archive_data,
                function( response ) {
    
                    if( true != response.success ) {
                        console.log( response.message );
                        return;
                    }
    
                    $archiveWrap.html( response.data.content );
    
                }
            )
            .fail( function() {
                $archiveWrap.html( '<p>Something went wrong</p>' );
            })
            .always( function() {
                $preloader.hide();
            });
    
        }

    }

    function is_case_study_archive() {

        return $body.hasClass( 'post-type-archive-case_study' ) || $body.hasClass( 'tax-industry' );

    }

    $(window).on('resize scroll', function(){
        $('.slicknav_nav').width($(window).width());
        $('.slicknav_nav').height($(window).height());
    });

});

function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');

        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }

    return query;
}